<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-links">
      <a routerLink="/privacy-policy" class="footer-link">
        {{ 'footer.privacyPolicy' | translate }}
      </a>
      <span class="footer-separator">|</span>
      <a routerLink="/terms-of-use" class="footer-link">
        {{ 'footer.termsOfUse' | translate }}
      </a>
      <span class="footer-separator">|</span>
      <a routerLink="/subprocessors" class="footer-link">
        {{ 'footer.subprocessors' | translate }}
      </a>
    </div>
    <div class="footer-copyright">
      © {{ currentYear }} Sameta. {{ 'footer.allRightsReserved' | translate }}
    </div>
  </div>
</footer>
